<template>
    <section class="mt-7 mb-16 sushi-elem">
        <article class="wrapper">
            <h2 class="text-orange">Formulário de contacto</h2>
            <div class="contact-container dots bg-white rounded-lg w-full mt-4 relative">
                <form @submit="(event) => sendRequest(event)">
                    <div class="flex mt-2">
                        <img src="/svg/ic_form_orange.svg" alt="form" class="inline-block mr-1 object-contain">
                        <h4 class="mt-1">preenche o formulário</h4>
                    </div>
                    <p class="text-danger error hidden">{{ apiError }}</p>
                    <p v-if="apiSuccess" class="text-success d8ffd8 error">{{ apiSuccess }}</p>

                    <div v-else>
                        <div class="lg:flex">
                            <div class="input-container w-full lg:pr-4 mt-4 input-error">
                                <label>Nome*</label>
                                <div class="input-box">
                                    <div class="icon name-icon"></div>
                                    <input v-model="name" type="text" class="form-control" placeholder="O teu nome">
                                </div>
                                <span v-if="fieldsWithError.name" class="text-danger error">{{ fieldsWithError.name }}</span>
                            </div>
                            <div class="input-container w-full mt-4 input-error">
                                <label>Email*</label>
                                <div class="input-box">
                                    <div class="icon email-icon"></div>
                                    <input v-model="email" type="text" class="form-control" placeholder="Email">
                                </div>
                                <span v-if="fieldsWithError.email" class="text-danger error">{{ fieldsWithError.email }}</span>
                            </div>
                        </div>
                        <div class="input-container w-full mt-4">
                            <label>Mensagem*</label>
                            <div class="input-box">
                                <div class="icon email-icon"></div>
                                <textarea v-model="message" name="mensage" id="contact-us-field" cols="30" rows="10" placeholder="Escreve aqui a tua mensagem"></textarea>
                            </div>
                            <span v-if="fieldsWithError.message" class="text-danger error">{{ fieldsWithError.message }}</span>
                        </div>
                        <div class="flex flex-col-reverse lg:flex-row lg:justify-between mt-4">
                            <button class="btn-bg">Enviar</button>
                            <p class="text-info mt-4">*campos obrigatórios</p>
                        </div>
                    </div>

                </form>
            </div>
        </article>
    </section>
</template>

<script>

export default {
    props: {
        formFields: {type: Object, required: false, default: () => {}},
        formTitle: {type: String},
        formDescription: {type: String}
    },
    methods: {
        sendRequest(e){
            e.preventDefault()
            this.fieldsWithError = []
            this.apiError = ''
            let payload = {}
            payload["name"] = this.name
            payload["email"] = this.email
            payload["message"] = this.message
            this.$axios.post("/api/talk-to-us", payload)
                .then(response => {
                    if(response.data.message){
                        this.apiSuccess = response.data.message;

                        this.fieldsWithError = [];
                        this.name = null;
                        this.email = null;
                        this.message = null;
                    }
                    console.log(response)
                })
                .catch(error => {
                    this.apiError = error.response.data.message

                    if(error.response.data.errors){
                        for(const [key, value] of Object.entries(error.response.data.errors)){
                            this.fieldsWithError[key] = value[0]
                            console.log(key, value)
                        }
                    }
                    
                });
        },
    },
    mounted(){
        //pass prop fields into state
        if(this.formFields){
            for (let [fieldName, fieldValues] of Object.entries(this.formFields)) {
                fieldValues.inputData = ""
                this.fields[fieldName] = fieldValues
            }
        }
    },
    data: () => ({
        name: null,
        email: null,
        message: null,
        fields: {},
        apiError: "",
        apiSuccess: false,
        fieldsWithError: []
    })
}
</script>

